import { animated } from "@react-spring/web";
import styled from "styled-components";

export const DialogLayout = styled(animated.div)`
  min-height: 200px;
  width: clamp(20vw, 420px, calc(100vw - 64px));
`;
